import {AxiosResponse} from 'axios'
import {corporateApi} from '../../../../setup/axios/CorporateApi'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {IHrProcessModel} from './HrProcessModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const HR_PROCESS_CREATE_URL = `${API_URL}api/v1/hrprocess/create`
export const HR_PROCESS_GET_ALL_URL = `${API_URL}api/v1/hrprocess/getAll`
export const HR_PROCESS_UPDATE_URL = `${API_URL}api/v1/hrprocess/update/`
export const HR_PROCESS_DELETE_URL = `${API_URL}api/v1/hrprocess/delete/`

export function createHrProcess(name: string): Promise<AxiosResponse<ApiResponse<IHrProcessModel>>> {
  return corporateApi.post(HR_PROCESS_CREATE_URL, {name})
}

export function loadHrProcesses(
  page = 0,
  size = 10
): Promise<AxiosResponse<ApiResponse<PageResponse<IHrProcessModel>>>> {
  return corporateApi.get(HR_PROCESS_GET_ALL_URL, {params: {page, size}})
}

export function updateHrProcess(
  hrProcessId: string,
  name: string
): Promise<AxiosResponse<ApiResponse<IHrProcessModel>>> {
  return corporateApi.patch(HR_PROCESS_UPDATE_URL + hrProcessId, {name})
}

export function deleteHrProcess(hrProcessId: string) {
  return corporateApi.delete(HR_PROCESS_DELETE_URL + hrProcessId)
}
